import { useParams } from 'react-router';
import { useGetInsuranceProductQuery } from '../../../api/queries/getInsuranceProduct';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import InsuranceProductDetailsInnerPage from './InsuranceProductDetailsInnerPage';

const InsuranceProductDetails = () => {
    const { insuranceProductId } = useParams<{ insuranceProductId: string }>();

    const { data, loading } = useGetInsuranceProductQuery({
        fetchPolicy: 'network-only',
        variables: { id: insuranceProductId },
    });

    const product = data?.product;

    if (!product && loading) {
        return <LoadingElement />;
    }

    if (!product) {
        return <NotFoundResult />;
    }

    return <InsuranceProductDetailsInnerPage insurance={product} />;
};

export default InsuranceProductDetails;
